import bookingStatusService from "@/services/bookingStatusService";

const state = () => ({
  all: []
});

const actions = {
  async findAll({ commit, dispatch }) {
    try {
      const res = await bookingStatusService.findAll();
      commit("setAll", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsstatus-Typen konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async updateColorsAndVisibility({ dispatch }, formData) {
    try {
      await bookingStatusService.updateColorsAndVisibility(formData);
      dispatch(
        "common/showSuccess",
        "Buchungsstatus-Farben wurden aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsstatus-Farben konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
